export const fetchWorkflows = () => ({
    method: 'GET',
    url: '/workflows',
});

export const fetchWorkflow = (workflowId) => ({
    method: 'GET',
    url: `/workflows/${workflowId}`,
});

export const fetchWorkflowsByUserGroups = () => ({
    method: 'GET',
    url: '/workflows/byUserGroups',
});

export const deleteWorkflow = (workflowId) => ({
    method: 'DELETE',
    url: `/workflows/${workflowId}`,
});

export const createWorkflow = (data) => ({
    method: 'POST',
    url: '/workflows',
    data
});

export const updateWorkflow = (data) => ({
    method: 'PUT',
    url: `/workflows/${data._id}`,
    data
});